import Immutable from 'immutable';
import { RawUser, User } from 'records/User';
import GQLRequest from 'utils/GQLRequest';

export const getUsers = async (
  projectid: string
): Promise<Immutable.List<User>> => {
  const { users } = await new GQLRequest()
    .query(
      `
      query Users($projectid: String!) {
        users(id: $projectid) {
          id
          email
          profile {
            firstname
            lastname
            company
            role
            discipline
            additionalinfoneeded
          }
        }
      }
      `
    )
    .variables({ projectid })
    .json<{ users: RawUser[] }>();

  return Immutable.List(users.map(User.deserialize));
};

export const addUser = async (
  projectId: string,
  email: string,
  role: string
): Promise<User> => {
  const { addUser: rawUser } = await new GQLRequest()
    .query(
      `
      mutation AddUser($email: String!, $projectId: String!, $role: String) {
        addUser(email: $email, projectId: $projectId, role: $role) {
            id
            email
        }
      }
      `
    )
    .variables({ email, projectId, role })
    .json<{ addUser: RawUser }>();

  return User.deserialize(rawUser);
};

export const removeUserFromProject = async (
  projectid: string,
  userid: string
): Promise<Response> => {
  const result = await new GQLRequest()
    .query(
      `
      mutation RemoveUserFromProject($projectid: String!, $userid: String!) {
        removeUserFromProject(projectid: $projectid, userid: $userid)
      }
      `
    )
    .variables({ projectid, userid })
    .run();

  return result;
};

export const startTrial = async (coupon: string): Promise<boolean> => {
  const result = await new GQLRequest()
    .query(
      `
      mutation StartTrial($input: NewTrial!) {
        startTrial(input: $input)
      }
      `
    )
    .variables({ input: { coupon } })
    .json<{ startTrial: string }>();

  return result.startTrial === 'Ok';
};

export const createStripeIntent = async (): Promise<string> => {
  const result = await new GQLRequest()
    .query(
      `
      mutation createStripeIntent{
      createStripeIntent {
        secret
        }
      }
    `
    )
    .variables({})
    .json<{ createStripeIntent: { secret: string } }>();

  return result.createStripeIntent.secret;
};

export interface ExportItem {
  url: string;
  extension: string;
}

export const exportXLSXUsers = async (
  projectid: string,
  sortfield: string,
  sortdirection: string
): Promise<ExportItem> => {
  const result = await new GQLRequest()
    .query(
      `
    query exportUsers($projectid: String!, $sortfield: String, $sortdirection: ExportSortDirection){
    exportUsers(projectid: $projectid, sortfield: $sortfield, sortdirection: $sortdirection)	{
      url
      extension
      }
    }
    `
    )
    .variables({ projectid, sortfield, sortdirection })
    .json<{ exportUsers: { url: string; extension: string } }>();

  return result.exportUsers;
};

export const canPurchase = async (): Promise<boolean> => {
  const result = await new GQLRequest()
    .query(
      `
      query CanPurchase() {
        canPurchase()
      }
      `
    )
    .variables({})
    .json<{ canPurchase: boolean }>();

  return result.canPurchase;
};

export default {
  getUsers,
  addUser,
  removeUserFromProject,
  startTrial,
  exportXLSXUsers,
  canPurchase,
};
